import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { useMemo, useState } from 'react'
import { When } from 'react-if'

import { parseYAMLValues, safeCypressID } from '@/utils'

import { JsonDataViewer } from '../JsonViewer'

export type HistoryVersionModalProps = {
  data: string
  name: string
  restoreVersion: () => void
  notes?: string
}

export const HistoryVersionModal = ({
  data,
  name,
  notes,
  restoreVersion,
}: HistoryVersionModalProps) => {
  const [open, setOpen] = useState(false)
  const openModal = () => setOpen(true)
  const closeModal = () => setOpen(false)

  const onRestore = () => {
    try {
      restoreVersion?.()
      closeModal()
    } catch (e) {
      console.error('Error restoring version', e)
    }
  }
  const value = useMemo(() => {
    try {
      return JSON.parse(data)
    } catch (e) {
      return null
    }
  }, [data])
  if (!value) {
    return null
  }
  return (
    <>
      <Button id={safeCypressID('view version')} onClick={openModal}>
        View version
      </Button>
      <When condition={open}>
        <Dialog maxWidth="xl" open={open} onClose={closeModal}>
          <DialogTitle id={safeCypressID('version name')}>
            Version {name}
          </DialogTitle>
          <DialogContent>
            <Typography id={safeCypressID('version notes')} sx={{ mb: 2 }}>
              {notes}
            </Typography>
            <JsonDataViewer
              data={parseYAMLValues(JSON.parse(data))}
              rootName={name}
            />
          </DialogContent>
          <DialogActions>
            <Button
              id={safeCypressID('close')}
              variant="text"
              onClick={closeModal}
            >
              Close
            </Button>
            <Button
              id={safeCypressID('restore')}
              variant="text"
              onClick={onRestore}
            >
              Restore Version
            </Button>
          </DialogActions>
        </Dialog>
      </When>
    </>
  )
}
